import { render } from "./DashboardWelcome.vue?vue&type=template&id=096137f9"
import script from "./DashboardWelcome.vue?vue&type=script&lang=js"
export * from "./DashboardWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__